/*
 * Payment result pages: fill the order code and rewrite the order-specific
 * links from the payment gateway's redirect query string. Everything degrades
 * gracefully: if a param is missing, the chip stays hidden and links keep
 * their server-rendered fallback href.
 *
 * Param keys are configured via data attributes on [data-payment-result],
 * each a comma-separated list of accepted names (first match wins).
 */
(function () {
  var root = document.querySelector('[data-payment-result]');
  if (!root) return;

  var params = new URLSearchParams(window.location.search);

  function firstParam(keys) {
    var names = (keys || '').split(',');
    for (var i = 0; i < names.length; i++) {
      var name = names[i].trim();
      if (name && params.get(name)) return params.get(name);
    }
    return '';
  }

  // Only allow root-relative or absolute http(s) URLs (no javascript:, data:, etc.)
  function safeUrl(url) {
    if (!url) return '';
    if (url.charAt(0) === '/' && url.charAt(1) !== '/') return url;
    if (/^https?:\/\//i.test(url)) return url;
    return '';
  }

  var code = firstParam(root.dataset.orderParam);
  if (code) {
    var codeEl = root.querySelector('[data-order-code]');
    var chip = root.querySelector('[data-order]');
    if (codeEl && chip) {
      codeEl.textContent = code;
      chip.hidden = false;
    }
  }

  function applyLink(selector, keys) {
    var url = safeUrl(firstParam(keys));
    if (!url) return;
    var el = root.querySelector(selector);
    if (el) el.setAttribute('href', url);
  }

  applyLink('.js-resume-link', root.dataset.resumeParam);
  applyLink('.js-status-link', root.dataset.statusParam);
})();
